"use client";

import type { FC, Ref } from "react";
import { useTranslation } from "react-i18next";

import { DocumentDownloadTemplate } from "../DocumentDownloadTemplate";

export interface OTDTemplateProps {
  signEndpoint?: string;
  downloadEndpoint?: string;
  viewEndpoint?: string;
}

/**
 * @deprecated Use DocumentViewerTemplate instead
 */
export const OTDTemplate: FC<
  OTDTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ signEndpoint, downloadEndpoint, viewEndpoint, ref }) => {
  const { t } = useTranslation();

  return (
    <DocumentDownloadTemplate
      ref={ref}
      signEndpoint={signEndpoint}
      downloadEndpoint={downloadEndpoint}
      viewEndpoint={viewEndpoint}
      variant="default"
      title={t("otd.title")}
      description={t("otd.description")}
      readLabel={t("otd.readLabel")}
      acknowledgementLabel={t("otd.acknowledgementLabel")}
      documentTitle={t("otd.documentTitle")}
      documentSubtitle={t("otd.documentSubtitle")}
      value={t("otd.value")}
    />
  );
};
